<template>
  <div>
    <el-tag
      v-for="(media, index) in mediaList"
      :key="index"
      class="tab-tag"
      :type="activeTag === index ? '' : 'info'"
      @click="activeTag = index"
    >素材{{ index + 1 }}</el-tag>
    <div class="content-container">
      <div class="title-text">基本信息</div>
      <MediaBaseInfo :mediaModel="mediaModel" />
      <template v-if="mediaModel.minIcon">
        <div class="title-text">封面图</div>
        <el-image :src="mediaModel.minIcon" :preview-src-list="[mediaModel.minIcon]" style="width:300px;background-color:#3e649a;"></el-image>
      </template>
      <template v-if="mediaModel.tipsDetail">
        <div class="title-text">广告提示语</div>
        <el-card
          class="content-box"
          shadow="never"
          :body-style="{ padding: 0 }"
          :header="convertTempName(mediaModel.tipsTempId)"
        >
          <AdTipsDetail :tipsDetail="JSON.parse(mediaModel.tipsDetail)" />
        </el-card>
      </template>
      <template v-if="exsitEvent">
        <div class="title-text">交互事件</div>
        <TargetEvent
          :keyEventList="mediaModel.keyEventList"
          :autoEventList="mediaModel.autoEventList"
          :voiceEventList="mediaModel.voiceEventList"
          :disabled="true"
        />
      </template>
      <template v-if="mediaModel.clickTrackList && mediaModel.clickTrackList.length">
        <div class="title-text">监测代码</div>
        <TrackCodeDetail title="点击监测" :trackList="mediaModel.clickTrackList" />
      </template>
    </div>
  </div>
</template>

<script>
import MediaBaseInfo from '@/components/media/MediaBaseInfo.vue'
import AdTipsDetail from '@/components/media/AdTipsDetail.vue'
import TargetEvent from '@/components/targetEvent/index.vue'
import TrackCodeDetail from './TrackCodeDetail.vue'

export default {
  components: {
    MediaBaseInfo,
    AdTipsDetail,
    TargetEvent,
    TrackCodeDetail,
  },
  props: {
    mediaList: {
      type: Array,
      default: () => [],
    },
    spaceTempList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeTag: 0,
    }
  },
  computed: {
    mediaModel() {
      return this.mediaList[this.activeTag]
    },
    exsitEvent() {
      return (this.mediaModel.keyEventList && this.mediaModel.keyEventList[0].targetTempId > -1) ||
        (this.mediaModel.voiceEventList && this.mediaModel.voiceEventList[0].targetTempId > -1) ||
        (this.mediaModel.autoEventList && this.mediaModel.autoEventList[0].targetTempId > -1)
    },
  },
  methods: {
    convertTempName(tipsTempId) {
      const spaceTemp = this.spaceTempList.find(item => item.tempId === tipsTempId)
      return spaceTemp ? spaceTemp.tempName : '自定义'
    },
  },
}
</script>

<style lang="stylus" scoped>
.tab-tag
  margin 10px 0 0 16px
  cursor pointer
.content-container
  margin 0 16px
</style>
